import {Track} from '@app/web-player/tracks/track';
import {MediaItem} from '@common/player/media-item';
import {getTrackImageSrc} from '@app/web-player/tracks/track-image/track-image';
import {Album} from '@app/web-player/albums/album';
import {guessPlayerProvider} from '@common/player/utils/guess-player-provider';
import {hydrateTrackMedia} from '@app/web-player/media-image/media-image';

export function trackToMediaItem(
  track: Track,
  queueGroupId?: string | number
): MediaItem<Track> {
  const hydratedTrack = hydrateTrackMedia(track);
  const provider: MediaItem['provider'] = hydratedTrack.src
    ? guessPlayerProvider(hydratedTrack.src, hydratedTrack?.player_type)
    : 'youtube';

  if (!hydratedTrack.src || provider === 'youtube') {
    return {
      id: hydratedTrack.id,
      provider: 'youtube',
      meta: hydratedTrack,
      src: hydratedTrack.src ? hydratedTrack.src : 'resolve',
      groupId: queueGroupId,
    };
  }

  return {
    id: hydratedTrack.id,
    src: hydratedTrack.src,
    playerType: hydratedTrack.player_type,
    provider,
    meta: hydratedTrack,
    poster: getTrackImageSrc(hydratedTrack, 'square'),
    groupId: queueGroupId,
  };
}

export function tracksToMediaItems(
  tracks: Track[],
  queueGroupId?: string,
  album?: Album
) {
  return tracks.map(track => {
    if (album && !track.album) {
      track = {
        ...track,
        album: {...album, tracks: undefined},
      };
    }
    return trackToMediaItem(track, queueGroupId);
  });
}
